<template>
    <nav class="nav menu-mobile" :class="{'nav--toggle': bMenuShow}">
        <div class="header__menu menu menu--mobile menu-mobile__header menu-mobile__header--nav">
            <button class="menu__toggle menu__toggle--mobile" @click="hideMenu()">
                <img src="/images/menu-open-mob.svg" />
            </button>

            <div class="menu__logo logo">
                <a href="/">
                    <img :src="pageProperties.logoCompanyPath" />
                </a>
            </div>
        </div>

        <div class="nav__wrapper">
            <ul class="nav-list nav__list">
                <li
                    v-if="$Auth.isEmployee() || $Auth.isManager() || $Auth.isHr()"
                    class="nav-module nav-list__module"
                >
                    <span class="nav-module__title">
                        {{ $t('vacations.vacations') }}
                    </span>

                    <router-link
                        v-if="($Auth.isEmployee() && planningPeriod.menu_active)
                            || ($Auth.isManager() && planningPeriod.active)
                            || $Auth.isHr()
                        "
                        class="nav-link nav-module__link nav-module__link--plan"
                        tag="a"
                        to="/vacations/plan"
                    >
                        <span @click="hideMenu()" class="nav-wrapper nav-link__wrapper nav-link__wrapper--plan">
                            <img
                                class="nav-wrapper__icon"
                                src="/images/star.svg"
                                alt="star"
                            />

                            {{ $t('vacations.plan_for_year', {year: planningPeriod.planning_year}) }}
                        </span>
                    </router-link>

                    <router-link
                        v-if="$Auth.isEmployee()"
                        class="nav-link nav-module__link"
                        tag="a"
                        to="/vacations/my"
                    >
                        <span @click="hideMenu()" class="nav-wrapper nav-link__wrapper">
                            <svg
                                class="nav-wrapper__icon"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M5.84211 8.5L3 9.11111C3.77211 4.51923 6.01453 3.00429 8.21053 3.00001C9.63016 2.99696 11.0299 3.62701 12 4.22223C12.9701 3.62701 14.3684 3.00001 15.7895 3.00001C17.9736 3.00001 20.2279 4.51923 21 9.11111L18.1579 8.5C18.4227 9.78334 19.0048 12.0396 18.1579 14C16.7463 12.3665 13.4826 10.4001 12 9C10.5174 10.4001 7.25368 12.3665 5.84211 14C4.99516 12.0402 5.57732 9.78334 5.84211 8.5Z"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M12 9C11.2451 10.6667 10.1891 14.7999 12 18"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                />
                                <path
                                    d="M17 21H7C7 21 9 18 12 18C15 18 17 21 17 21Z"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>

                            {{ $t('vacations.my_vacations') }}
                        </span>
                    </router-link>

                    <router-link
                        v-if="$Auth.isManager()"
                        class="nav-link nav-module__link"
                        tag="a"
                        to="/vacations/subordinates"
                    >
                        <span @click="hideMenu()" class="nav-wrapper nav-link__wrapper">
                            <svg
                                class="nav-wrapper__icon"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <circle
                                    cx="15"
                                    cy="11"
                                    r="4"
                                    stroke-width="2"
                                />
                                <path
                                    d="M22 22C22 18.134 18.866 15 15 15C11.134 15 8 18.134 8 22"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                />
                                <path
                                    d="M2 18C2 15.5 3.5 13 6.12842 11.6379C4.29421 10.897 3 9.09966 3 7C3 4.23858 5.23858 2 8 2C9.36273 2 10.5981 2.54516 11.5 3.42928"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>

                            {{ $t('vacations.subordinates_vacations') }}
                        </span>
                    </router-link>

                    <router-link
                        v-if="$Auth.isHr()"
                        class="nav-link nav-module__link"
                        tag="a"
                        to="/vacations/hr-administration"
                    >
                        <span @click="hideMenu()" class="nav-wrapper nav-link__wrapper">
                            <svg
                                class="nav-wrapper__icon"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <rect
                                    x="8"
                                    y="3"
                                    width="13"
                                    height="18"
                                    rx="3"
                                    stroke-width="2"
                                />
                                <path
                                    d="M4 6V6C3.38713 6.30643 3 6.93283 3 7.61803V16.382C3 17.0672 3.38713 17.6936 4 18V18"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                />
                                <path
                                    d="M12 8H17M12 12H17M12 16H14.5"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                />
                            </svg>

                            {{ $t('vacations.hr_administration') }}
                        </span>
                    </router-link>

                    <router-link
                        class="nav-link nav-module__link"
                        tag="a"
                        to="/vacations/schedule"
                    >
                        <span @click="hideMenu()" class="nav-wrapper nav-link__wrapper">
                            <svg
                                class="nav-wrapper__icon"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M4 11V18C4 19.6569 5.34315 21 7 21H17C18.6569 21 20 19.6569 20 18V11M4 11V8C4 6.34315 5.34315 5 7 5H17C18.6569 5 20 6.34315 20 8V11M4 11H20M8 3V7M16 3V7"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                />
                                <path
                                    d="M11 15H12V18"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>

                            {{ $t('vacations.absence_schedule') }}
                        </span>
                    </router-link>
                </li>

                <li class="nav-module nav-list__module">
                    <span class="nav-module__title">
                        {{ $t('structure.company') }}
                    </span>

                    <router-link
                        class="nav-link nav-module__link"
                        tag="a"
                        to="/structure/units"
                    >
                        <span @click="hideMenu()" class="nav-wrapper nav-link__wrapper">
                            <svg
                                class="nav-wrapper__icon"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <circle
                                    cx="5.5"
                                    cy="6.5"
                                    r="1.5"
                                    stroke-width="2"
                                />
                                <circle
                                    cx="4"
                                    cy="16"
                                    r="2"
                                    stroke-width="2"
                                />
                                <circle
                                    cx="14.5"
                                    cy="20.5"
                                    r="1.5"
                                    stroke-width="2"
                                />
                                <circle
                                    cx="20.5"
                                    cy="12.5"
                                    r="1.5"
                                    stroke-width="2"
                                />
                                <circle
                                    cx="17"
                                    cy="4"
                                    r="2"
                                    stroke-width="2"
                                />
                                <path
                                    d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
                                    stroke-width="2"
                                />
                            </svg>

                            {{ $t('structure.structure_units') }}
                        </span>
                    </router-link>

                    <router-link
                        class="nav-link nav-module__link"
                        tag="a"
                        to="/structure/persons"
                    >
                        <span @click="hideMenu()" class="nav-wrapper nav-link__wrapper">
                            <svg
                                class="nav-wrapper__icon"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M18.5352 11.5355C18.9994 11.0713 19.3677 10.5201 19.619 9.91343C19.8703 9.3068 19.9996 8.65662 19.9996 8.00001C19.9996 7.3434 19.8703 6.69322 19.619 6.08659C19.3677 5.47997 18.9994 4.92877 18.5352 4.46448"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                />
                                <path
                                    d="M17 21C17 18.7909 15.2091 17 13 17H7C4.79086 17 3 18.7909 3 21M15 8C15 10.7614 12.7614 13 10 13C7.23858 13 5 10.7614 5 8C5 5.23858 7.23858 3 10 3C12.7614 3 15 5.23858 15 8Z"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                />
                                <path
                                    d="M19.5 17C21 17.5 22 19.5 22 21"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                />
                            </svg>

                            {{ $t('structure.persons') }}
                        </span>
                    </router-link>

                    <router-link
                        v-if="$Auth.isManager() || $Auth.isHr() || $Auth.isAdmin()"
                        class="nav-link nav-module__link"
                        tag="a"
                        to="/vacations/balances"
                    >
                        <span @click="hideMenu()" class="nav-wrapper nav-link__wrapper">
                            <svg
                                class="nav-wrapper__icon"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M3 8V18C3 19.6569 4.34315 21 6 21H8M3 8V6C3 4.34315 4.34315 3 6 3H18C19.6569 3 21 4.34315 21 6V8M3 8H21M21 8V18C21 19.6569 19.6569 21 18 21H16"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                />
                                <path
                                    d="M12 22V15M12 15L9.5 17M12 15L14.5 17"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                />
                            </svg>

                            {{ $t('vacations.balances.balances') }}
                        </span>
                    </router-link>
                </li>

                <li
                    v-if="$Auth.isHr() || $Auth.isAdmin()"
                    class="nav-module nav-list__module"
                >
                    <span class="nav-module__title">
                        {{ $t('settings.settings') }}
                    </span>

                    <router-link
                        v-if="$Auth.isAdmin()"
                        class="nav-link nav-module__link"
                        tag="a"
                        :to="{name: 'settings.common_name'}"
                    >
                        <span @click="hideMenu()" class="nav-wrapper nav-link__wrapper">
                            <svg
                                class="nav-wrapper__icon"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M20.2857 18H22M20.2857 18C20.2857 17.3623 20.0246 16.7856 19.6034 16.371M20.2857 18C20.2857 18.6317 20.0295 19.2036 19.6152 19.6173M18 20.2857V22M18 20.2857C17.3693 20.2857 16.7983 20.0303 16.3848 19.6173M18 20.2857C18.6307 20.2857 19.2017 20.0303 19.6152 19.6173M15.7143 18H14M15.7143 18C15.7143 18.6317 15.9705 19.2036 16.3848 19.6173M15.7143 18C15.7143 17.3623 15.9754 16.7856 16.3966 16.371M18 15.7143V14M18 15.7143C18.6247 15.7143 19.1908 15.9649 19.6034 16.371M18 15.7143C17.3753 15.7143 16.8092 15.9649 16.3966 16.371M16.3848 19.6173L15.1429 20.8592M19.6034 16.371L20.8571 15.1173M16.3966 16.371L15.1429 15.1173M19.6152 19.6173L20.8571 20.8592"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M10 20H5C3.34315 20 2 18.6569 2 17V6C2 4.34315 3.34315 3 5 3H19C20.6569 3 22 4.34315 22 6V11"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M7 8H17"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M7 13H11"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>

                            {{ $t('settings.menu.common') }}
                        </span>
                    </router-link>

                    <router-link
                        class="nav-link nav-module__link"
                        tag="a"
                        :to="{name: 'settings.vacations_name'}"
                    >
                        <span @click="hideMenu()" class="nav-wrapper nav-link__wrapper">
                            <svg
                                class="nav-wrapper__icon"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                                    stroke-width="2"
                                />
                                <path
                                    d="M13.7655 2.152C13.3985 2 12.9325 2 12.0005 2C11.0685 2 10.6025 2 10.2355 2.152C9.99263 2.25251 9.772 2.3999 9.58617 2.58572C9.40035 2.77155 9.25296 2.99218 9.15245 3.235C9.06045 3.458 9.02345 3.719 9.00945 4.098C9.00322 4.37199 8.92745 4.6399 8.78926 4.87657C8.65107 5.11324 8.455 5.31091 8.21945 5.451C7.98035 5.58504 7.71109 5.6561 7.43698 5.6575C7.16288 5.6589 6.89291 5.59059 6.65245 5.459C6.31645 5.281 6.07345 5.183 5.83245 5.151C5.30677 5.08187 4.77515 5.22431 4.35445 5.547C4.04045 5.79 3.80645 6.193 3.34045 7C2.87445 7.807 2.64045 8.21 2.58945 8.605C2.55509 8.86545 2.57237 9.13012 2.64032 9.38389C2.70826 9.63767 2.82554 9.87556 2.98545 10.084C3.13345 10.276 3.34045 10.437 3.66145 10.639C4.13445 10.936 4.43845 11.442 4.43845 12C4.43845 12.558 4.13445 13.064 3.66145 13.36C3.34045 13.563 3.13245 13.724 2.98545 13.916C2.82554 14.1244 2.70826 14.3623 2.64032 14.6161C2.57237 14.8699 2.55509 15.1345 2.58945 15.395C2.64145 15.789 2.87445 16.193 3.33945 17C3.80645 17.807 4.03945 18.21 4.35445 18.453C4.56289 18.6129 4.80078 18.7302 5.05456 18.7981C5.30833 18.8661 5.573 18.8834 5.83345 18.849C6.07345 18.817 6.31645 18.719 6.65245 18.541C6.89291 18.4094 7.16288 18.3411 7.43698 18.3425C7.71109 18.3439 7.98035 18.415 8.21945 18.549C8.70245 18.829 8.98945 19.344 9.00945 19.902C9.02345 20.282 9.05945 20.542 9.15245 20.765C9.25296 21.0078 9.40035 21.2284 9.58617 21.4143C9.772 21.6001 9.99263 21.7475 10.2355 21.848C10.6025 22 11.0685 22 12.0005 22C12.9325 22 13.3985 22 13.7655 21.848C14.0083 21.7475 14.2289 21.6001 14.4147 21.4143C14.6006 21.2284 14.7479 21.0078 14.8484 20.765C14.9404 20.542 14.9775 20.282 14.9915 19.902C15.0115 19.344 15.2985 18.828 15.7815 18.549C16.0206 18.415 16.2898 18.3439 16.5639 18.3425C16.838 18.3411 17.108 18.4094 17.3484 18.541C17.6844 18.719 17.9274 18.817 18.1674 18.849C18.4279 18.8834 18.6926 18.8661 18.9463 18.7981C19.2001 18.7302 19.438 18.6129 19.6465 18.453C19.9615 18.211 20.1944 17.807 20.6604 17C21.1264 16.193 21.3604 15.79 21.4114 15.395C21.4458 15.1345 21.4285 14.8699 21.3606 14.6161C21.2926 14.3623 21.1754 14.1244 21.0154 13.916C20.8674 13.724 20.6605 13.563 20.3395 13.361C20.1052 13.2186 19.911 13.019 19.775 12.7809C19.6391 12.5428 19.566 12.2741 19.5625 12C19.5625 11.442 19.8665 10.936 20.3395 10.64C20.6605 10.437 20.8684 10.276 21.0154 10.084C21.1754 9.87556 21.2926 9.63767 21.3606 9.38389C21.4285 9.13012 21.4458 8.86545 21.4114 8.605C21.3594 8.211 21.1264 7.807 20.6614 7C20.1944 6.193 19.9615 5.79 19.6465 5.547C19.438 5.38709 19.2001 5.26981 18.9463 5.20187C18.6926 5.13392 18.4279 5.11664 18.1674 5.151C17.9274 5.183 17.6845 5.281 17.3475 5.459C17.1071 5.59042 16.8373 5.65862 16.5634 5.65722C16.2895 5.65582 16.0204 5.58486 15.7815 5.451C15.5459 5.31091 15.3498 5.11324 15.2116 4.87657C15.0734 4.6399 14.9977 4.37199 14.9915 4.098C14.9775 3.718 14.9414 3.458 14.8484 3.235C14.7479 2.99218 14.6006 2.77155 14.4147 2.58572C14.2289 2.3999 14.0083 2.25251 13.7655 2.152Z"
                                    stroke-width="2"
                                />
                            </svg>

                            {{ $t('settings.menu.vacations') }}
                        </span>
                    </router-link>

                    <router-link
                        class="nav-link nav-module__link"
                        tag="a"
                        :to="{name: 'settings.notifications_name'}"
                    >
                        <span @click="hideMenu()" class="nav-wrapper nav-link__wrapper">
                            <svg
                                class="nav-wrapper__icon"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M6.5507 3C4 5 3 6.5 3 10"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                />
                                <path
                                    d="M17.4493 3C20 5 21 6.5 21 10"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                />
                                <path
                                    d="M12 5.51121H10.7482C8.63987 5.51121 6.91543 7.16132 6.81208 9.28281C6.67169 12.1648 6.44202 14.3321 5 17.6009C10.2087 18.7075 14.1671 18.7749 19 17.6009C17.5418 14.2954 17.3903 12.1205 17.2377 9.18901C17.1292 7.10562 15.4132 5.51121 13.3425 5.51121H12ZM12 5.51121V3"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M15 19C15 20.6569 13.6569 22 12 22C10.3431 22 9 20.6569 9 19"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                />
                            </svg>

                            {{ $t('settings.menu.notifications') }}
                        </span>
                    </router-link>
                </li>

                <li class="nav-module nav-list__module">
                    <span class="nav-module__title">
                        {{ $t('help.menu.help_center') }}
                    </span>

                    <router-link
                        class="nav-link nav-module__link"
                        tag="a"
                        :to="{name: 'help.help'}"
                    >
                        <span @click="hideMenu()" class="nav-wrapper nav-link__wrapper">
                            <svg
                                class="nav-wrapper__icon"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M3 5C3 3.34315 4.34315 2 6 2H18C19.6569 2 21 3.34315 21 5V16C21 17.6569 19.6569 19 18 19H15L12.7071 21.2929C12.3166 21.6834 11.6834 21.6834 11.2929 21.2929L9 19H6C4.34315 19 3 17.6569 3 16V5Z"
                                    stroke-width="2"
                                    stroke-linejoin="round"
                                />
                                <circle
                                    cx="12"
                                    cy="16.5"
                                    r="0.5"
                                />
                                <path
                                    d="M9.5 7.49999C10.4653 5.5 13.5543 5.5 14.3265 7.49999C15.2919 9.99998 11.9133 11 11.9133 13"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                />
                            </svg>

                            {{ $t('help.help_instructions') }}
                        </span>
                    </router-link>
                </li>
            </ul>
        </div>
    </nav>
</template>

<script>
    export default {
        props: {
            bMenuShow: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {};
        },
        computed: {
            pageProperties() {
                return this.$store.state.pageProperties;
            },
            planningPeriod() {
                return this.$store.state.planningPeriod;
            },
        },
        methods: {
            hideMenu() {
                this.$parent.changeVisibilityMenu(true);
                this.$parent.changeVisibilityShadow(false);

                document.body.classList.remove('hidden-overflow-shadow');
            },
        },
    };
</script>
